module.exports = __webpack_public_path__ + "media/images/sales/weddingday/thumb-pricing-01-2271a3a755b00db239ec1f93fb0edd4b.svg";